<div id="assessment-details" class="row p-top-20">
  <div class="col-md-12 col-lg-12 col-xl-12">
    <div class="row no-margin">
      <!-- <div class="table-responsive" [dragula] = '"bag-task1"' [dragulaOptions]="options"> -->
      <!-- <div class="table-responsive">
        <div class="assignment-header">
          <div class="column column-5">
            <input type="checkbox" />
          </div>
          <div class="column column-5">
            #
          </div>
          <div class="column column-45">
            Question
          </div>
          <div class="column column-20">
            Type
          </div>
          <div class="column column-20">
            Points
          </div>
          <div class="column column-5">

          </div>
        </div>
        <div class="assignment-body">
          <div class="column column-5">
            <input type="checkbox" />
          </div>
          <div class="column column-5">
            #
          </div>
          <div class="column column-45">
            Question
          </div>
          <div class="column column-20">
            Type
          </div>
          <div class="column column-20">
            Points
          </div>
          <div class="column column-5">
          </div>
        </div>
        <div class="assignment-body">
          <div class="column column-5">
            <input type="checkbox" />
          </div>
          <div class="column column-5">
            #
          </div>
          <div class="column column-45">
            Question
          </div>
          <div class="column column-20">
            Type
          </div>
          <div class="column column-20">
            Points
          </div>
          <div class="column column-5">

          </div>
        </div>
        <div class="assignment-body">
          <div class="column column-5">
            <input type="checkbox" />
          </div>
          <div class="column column-5">
            #
          </div>
          <div class="column column-45">
            Question
          </div>
          <div class="column column-20">
            Type
          </div>
          <div class="column column-20">
            Points
          </div>
          <div class="column column-5">

          </div>
        </div>
        <div class="assignment-body">
          <div class="column column-5">
            <input type="checkbox" />
          </div>
          <div class="column column-5">
            #
          </div>
          <div class="column column-45">
            Question
          </div>
          <div class="column column-20">
            Type
          </div>
          <div class="column column-20">
            Points
          </div>
          <div class="column column-5">

          </div>
        </div>
      </div> -->
      <table class="dpg-ui-table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">First <i class="dpg-icon dpg-icon-administrator-white"></i></th>
              <th scope="col">Last <i class="dpg-icon dpg-icon-accessibility-white"></i></th>
              <th scope="col">Handle</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">1</th>
              <td>Mark</td>
              <td>Otto</td>
              <td>&#64;mdo</td>
            </tr>
            <tr>
              <th scope="row">2</th>
              <td>Jacob</td>
              <td>Thornton</td>
              <td>&#64;fat</td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>Larry</td>
              <td>the Bird</td>
              <td>&#64;twitter</td>
            </tr>
          </tbody>
        </table>
    </div>
  </div>
</div>